import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { Payment } from '@adornis/payments/db/payments.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Order } from '../../../db/Order.js';
import { ProductRegistration } from '../../../features/product-registration/db/ProductRegistration.js';
import { LASPaymentRecipient } from './LASPaymentRecipient.js';

@Entity()
export class LASPayment extends Payment {
  static override _class = 'LASPayment';
  static override _collectionName = 'payments';

  @validate(nonOptional())
  @Field(type => String)
  geschaeftsvorfallID!: string;

  @validate(nonOptional())
  @Field(type => LASPaymentRecipient, { default: v => v ?? new LASPaymentRecipient({}) })
  recipient!: LASPaymentRecipient;

  @Field(type => ProductRegistration)
  formData?: ProductRegistration;

  @Field(type => Order)
  orderBuffer?: Maybe<Order>;
}
